module.exports = __webpack_public_path__ + "img/4.709d3200.png";